import { breakpoints } from '../../../resources/scripts/config/breakpoints';

/**
 * Sets the offset of elements within a wrapper based on the provided values.
 *
 * @param {number} offsetImgfirst - The offset value for the first image elements.
 * @param {number} offsetImgSecond - The offset value for the second image elements.
 * @param {Element} wrapper - The wrapper element containing the elements to set the offset.
 * @return {void} No return value.
 */
function setElementOffset(offsetImgfirst, offsetImgSecond, wrapper) {
  const imagesFirst = wrapper.querySelectorAll('[data-editorial-grid-image-first]');
  const imagesSecond = wrapper.querySelectorAll('[data-editorial-grid-image-second]');

  imagesFirst.forEach((el) => {
    // eslint-disable-next-line no-param-reassign
    el.style.transform = `translateX(${offsetImgfirst}px)`;
  });

  imagesSecond.forEach((el) => {
    // eslint-disable-next-line no-param-reassign
    el.style.transform = `translateX(${offsetImgSecond}px)`;
  });
}

function handleMouseMove(wrapper, e) {
  const gridContent = document.querySelector('.editorial-grid__col--content');
  const contentRect = gridContent.getBoundingClientRect();

  // the value of the element offset
  const offset = {
    lg: 40,
    sm: 20,
  };

  if (e.x < contentRect.left) {
    setElementOffset(offset.sm, offset.lg, wrapper);
  } else if (e.x > contentRect.right) {
    setElementOffset(offset.lg * -1, offset.sm * -1, wrapper);
  } else {
    setElementOffset(0, 0, wrapper);
  }
}

function handleMouseLeave(wrapper) {
  setElementOffset(0, 0, wrapper);
}

/**
 * This function is responsible for handling the event related to the wrapper element.
 * It checks the window inner width and based on that, it adds or removes event listeners.
 */
function handlerEvent() {
  const wrappers = document.querySelectorAll('[data-editorial-grid]');

  wrappers.forEach((wrapper) => {
    const w = wrapper;
    // Create bound event handlers
    const handleMouseMoveBind = handleMouseMove.bind(null, w);
    const handleMouseLeaveBind = handleMouseLeave.bind(null, w);

    // Store the bound functions directly on the element
    if (!w.new_handleMouseMoveBind) {
      w.new_handleMouseMoveBind = handleMouseMoveBind;
    }
    if (!w.new_handleMouseLeaveBind) {
      w.new_handleMouseLeaveBind = handleMouseLeaveBind;
    }

    if (window.innerWidth > breakpoints.lg) {
      // Removing previous handlers, if they were added
      w.removeEventListener('mousemove', w.new_handleMouseMoveBind);
      w.removeEventListener('mouseleave', w.new_handleMouseLeaveBind);

      // Adding new handlers
      w.addEventListener('mousemove', w.new_handleMouseMoveBind);
      w.addEventListener('mouseleave', w.new_handleMouseLeaveBind);
    } else {
      // Removing handlers if the resolution is less than breakpoints.lg
      w.removeEventListener('mousemove', w.new_handleMouseMoveBind);
      w.removeEventListener('mouseleave', w.new_handleMouseLeaveBind);
    }
  });
}

window.addEventListener('DOMContentLoaded', handlerEvent);
window.addEventListener('resize', handlerEvent);
